import { savePermissionConfig } from '../application/save-permission-config'
import type { PermissionConfiguration } from '../domain/permission'
import { permissionConfig$ } from '../store'
import { notify, permissions as permissionsPort } from '../wiring'

const usePermissionConfigActions = () => {
	const save = async (config: PermissionConfiguration) => {
		const ok = await savePermissionConfig(permissionsPort, config, notify)
		if (ok) permissionConfig$.set(config)
		return ok
	}

	return { save }
}

export { usePermissionConfigActions }
